import { ElementRef, EventEmitter, OnChanges, OnInit, OnDestroy } from '@angular/core';
import { FileUploadService, FileUploadInformation } from '../fileupload.service';
var FileUploaderComponent = /** @class */ (function () {
    function FileUploaderComponent(fileSvc) {
        this.fileSvc = fileSvc;
        this.upload = new EventEmitter();
        this.Files = [];
    }
    FileUploaderComponent.prototype.ngOnDestroy = function () { };
    FileUploaderComponent.prototype.ngOnChanges = function () {
        this.ValidExtensions = this.validExtensions ? this.validExtensions.join(',') : '*';
    };
    FileUploaderComponent.prototype.ngOnInit = function () { };
    FileUploaderComponent.prototype.AddFiles = function () {
        if (this.file) {
            // Clear out the pending list of files
            this.Files = [];
            this.file.nativeElement.click();
        }
    };
    FileUploaderComponent.prototype.FileInputHandler = function () {
        var _files = this.file.nativeElement.files;
        if (_files && !!_files.length) {
            for (var i = 0, j = _files.length; i < j; ++i) {
                var _file = _files.item(i);
                this.Files.push({
                    File: _file,
                });
            }
        }
        // Return the list of files to be processed.
        this.upload.emit(this.Files);
        // Clear the file element
        this.file.nativeElement.value = '';
    };
    return FileUploaderComponent;
}());
export { FileUploaderComponent };
